import { render, staticRenderFns } from "./SelectComponent.vue?vue&type=template&id=02cf3d1c&scoped=true&"
import script from "./SelectComponent.vue?vue&type=script&lang=ts&"
export * from "./SelectComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SelectComponent.vue?vue&type=style&index=0&id=02cf3d1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cf3d1c",
  null
  
)

export default component.exports